import { TAGS_KEYS } from './tags.constants';

export const HUB_SEARCH_FILTER_KEYS = {
  [TAGS_KEYS.SPECIALTY]: 'specialty',
  [TAGS_KEYS.SUBSPECIALTY]: 'subspecialty',
  [TAGS_KEYS.CONTENT_TYPE]: 'contentType',
  [TAGS_KEYS.TARGET_AUDIENCE]: 'targetAudience',
  ORGANIZATIONS: 'organizations',
};

export const HUB_SEARCH_FILTERS_INITIAL_STATE = {
  [TAGS_KEYS.SPECIALTY]: [],
  [TAGS_KEYS.SUBSPECIALTY]: [],
  [TAGS_KEYS.CONTENT_TYPE]: [],
  [TAGS_KEYS.TARGET_AUDIENCE]: [],
  ORGANIZATIONS: [],
};
